import { FaUserDoctor } from "react-icons/fa6";
import { HiArrowTrendingUp } from "react-icons/hi2";
import { LuCalendarClock, LuUser } from "react-icons/lu";
import { MdDashboard, MdAdminPanelSettings } from "react-icons/md";
import { IoSettings } from "react-icons/io5";

// `permission` (optional) hides the item unless the admin holds it; items with no
// permission are always shown. Keys mirror the backend permission catalog.
export const SidebarLink = [
    { path: '/', label: 'Dashboard', icon: <LuCalendarClock size={24} />, permission: 'dashboard.view' },
    { path: '/appointment', label: 'Appointment', icon: <LuCalendarClock size={24} />, permission: 'appointments.view' },
    { path: '/transactions', label: 'Transactions', icon: <HiArrowTrendingUp size={24} />, permission: 'transactions.view' },
    { path: '/patients', label: 'Patients', icon: <LuUser size={24} />, permission: 'patients.view' },
    { path: '/doctors', label: 'Doctors', icon: <FaUserDoctor size={24} />, permission: 'doctors.view' },
    { path: '/verification', label: 'Verification', icon: <FaUserDoctor size={24} />, permission: 'doctors.manage' },
]

export const SidebarGroups = [
    {
        label: 'Management',
        icon: <MdDashboard size={24} />,
        links: [
            { path: '/category', label: 'Category', permission: 'categories.manage' },
            { path: '/banner', label: 'Banner', permission: 'banners.manage' },
        ],
    },
    {
        label: 'Moderation',
        icon: <MdDashboard size={24} />,
        links: [
            { path: '/reviews', label: 'Reviews', permission: 'reviews.moderate' },
            { path: '/call-history', label: 'Call History', permission: 'callhistory.view' },
        ],
    },
    {
        label: 'Symptom Intake',
        icon: <MdDashboard size={24} />,
        links: [
            { path: '/surveys', label: 'Surveys', permission: 'surveys.manage' },
            { path: '/intake-submissions', label: 'Submissions', permission: 'intake.view' },
        ],
    },
    {
        label: 'Administration',
        icon: <MdAdminPanelSettings size={24} />,
        links: [
            { path: '/admins', label: 'Admins', permission: 'admins.manage' },
            { path: '/roles', label: 'Roles & Permissions', permission: 'roles.manage' },
            { path: '/login-audit', label: 'Login Audit', permission: 'admins.manage' },
            { path: '/platform-fee', label: 'Platform Fee', permission: 'fees.manage' },
        ],
    },
    {
        label: 'Setting',
        icon: <IoSettings size={24} />,
        links: [
            { path: '/profile', label: 'Profile' },
            { path: '/faq', label: 'FAQ', permission: 'faqs.manage' },
            { path: '/countries', label: 'Countries', permission: 'countries.manage' },
            { path: '/regulators', label: 'Regulators', permission: 'countries.manage' },
            { path: '/privacy-policy', label: 'Privacy Policy', permission: 'content.manage' },
            { path: '/terms-&-condition', label: 'Terms & Condition', permission: 'content.manage' },
        ],
    },
]
